import React from 'react'

import Link from '@Pure/Link'

import { mergeDeep } from '@root/utility'

export let form =
{
	model: 'artist',
	name: 'artist',

	form_title: 'Artiste',

	fields:
	{
		'name':
		{
			label: 'Nom'
		},

		'disabled':
		{
			label: 'Désactivé',

			type: 'checkbox'
		},

		'images':
		{
			type: 'image',
			label: 'Images',
			multiple: true
		},

		'description':
		{
			label: 'Description',
			type: 'editor',
			images: false
		}
	},

	create_label: 'Créer cet artiste',

	get__deleteModalText: function (form_data)
	{
		var output =
		(
			<span>
				<p>
					Êtes vous sûr de vouloir supprimer cet artiste&nbsp;?
				</p>

				<div className="u-center">

					<div className="name-in-modal">

						{ form_data['artist[name]'] }

					</div>

				</div>
			</span>
		);

		return output;
	},

	get__createdMessage: function (model)
	{
		var output =
		(
			<div className="c-message c-message--green">
				<div className="c-message__content">
					Le nouvel artiste <strong> { model.name } </strong> a été créé.
					{ ' ' }
					<Link className="c-link c-link--highlighted c-link--green"
						href={ '/configuration/artistes/' + model.id }>
						Voir la page de l'artiste
					</Link>
				</div>
			</div>
		);

		return output;
	}
}

export let list =
{
	model: 'artist',
	title: 'Liste des artistes',
	link: '/configuration/artistes',
	creation_link: '/configuration/nouvel-artiste',
	creation_label: 'Nouvel artiste',
	header_map:
	{
		'Image': 'images.url',
		'Nom': 'name',
		'Description': 'description',
		'Produits actifs': 'linked_products',
		'Désactivé' : 'disabled'
	},
	image_fields: ['Image'],
	html_fields: ['Description'],
	row_link_base: '/configuration/artistes/',
	searched_prop: 'name'
}

let config = mergeDeep({ }, form);

config = mergeDeep(config, list);

export default config